<!--
 * @Description: 合作伙伴-编辑
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-06-08 17:18:43
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :permissionPage="permissionBase" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import baseMessage from '@/views/yuntuSales/marketing/partnerManage/components/baseMessage.vue'
const permissionBase = {
  save: 'lbu_partner_edit_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuPartnerManageEdit' }
</script>
